import CheckoutConfiguration from '../containers/checkout-configuration';

export default {
  path: ':organization/checkout-configuration',
  title: 'Checkout Configuration',
  indexRoute: {
    component: CheckoutConfiguration,
  },
};
